export default {
	name: 'GeneralInfo',
	props: {
		title: {
			type: String,
			required: true,
		},
		items: {
			type: Array,
			default: () => [],
			validator(value) {
				return value.every(
					(row) =>
						row && typeof row === 'object' && 'label' in row && 'value' in row,
				);
			},
		},
		imageUrl: {
			type: String,
			default: '',
		},
	},
	computed: {
		showIcon() {
			return !!this.$slots.icon;
		},
	},
};
